var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"manageHome"}},[_c('Avatar',{staticClass:"md-large md-elevation-5",attrs:{"src":_vm.user.avatar,"address":_vm.userName}}),_c('h2',[_vm._v(_vm._s(_vm.userName))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }